import {
  PropsWithChildren,
  useEffect,
  useRef
} from 'react';

export type ClickOutsideProps = PropsWithChildren<{
  className?: string;
  excludeElements?: HTMLElement[];
  onClickOutside: (event: MouseEvent) => void;
}>;

export function ClickOutside({
  className,
  onClickOutside,
  excludeElements = [],
  children
}: ClickOutsideProps) {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const handleClickOutside = (event: MouseEvent) => {
    const clickTarget = event.target as Node;
    if (
      !wrapperRef.current
      || wrapperRef.current.contains(clickTarget)
      || excludeElements.some((element) => element.contains(clickTarget))
      || [...document.querySelectorAll('.root-portal')].some((portal) => portal.contains(clickTarget))
    ) {
      return;
    }
    onClickOutside(event);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, []);

  return (
    <div className={className} ref={wrapperRef}>
      {children}
    </div>
  );
}
